if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          // const activeMediaRect = activeMedia.getBoundingClientRect();
          // // Don't scroll if the image is already in view
          // if (activeMediaRect.top > -0.5) return;
          // const top = activeMediaRect.top + window.scrollY;
          // window.scrollTo({ top: top, behavior: 'smooth' });
        
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}




document.addEventListener('DOMContentLoaded', function() {
  const mediaGallery = document.querySelector('media-gallery');
  if (!mediaGallery) return;

  const prevBtn = document.querySelector('.custom-arrow--prev');
  const nextBtn = document.querySelector('.custom-arrow--next');
  const thumbnails = document.querySelector('[id^="GalleryThumbnails"]');
  
  if (!prevBtn || !nextBtn || !thumbnails) return;

  function clickAdjacentThumbnail(direction) {
    const activeThumbnail = thumbnails.querySelector('button[aria-current="true"]');
    if (!activeThumbnail) return;

    const activeLi = activeThumbnail.closest('[data-target]');
    if (!activeLi) return;

    const allThumbnails = Array.from(thumbnails.querySelectorAll('[data-target]'));
    const currentIndex = allThumbnails.indexOf(activeLi);

    let targetIndex;
    if (direction === 'prev') {
      targetIndex = currentIndex > 0 ? currentIndex - 1 : allThumbnails.length - 1;
    } else {
      targetIndex = currentIndex < allThumbnails.length - 1 ? currentIndex + 1 : 0;
    }

    const targetButton = allThumbnails[targetIndex].querySelector('button');
    if (targetButton) {
      targetButton.click();
    }
  }

  prevBtn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    clickAdjacentThumbnail('prev');
  });

  nextBtn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    clickAdjacentThumbnail('next');
  });
});


// document.addEventListener('DOMContentLoaded', function() {
//   const mediaGallery = document.querySelector('media-gallery');
//   if (!mediaGallery) return;

//   const prevBtn = document.querySelector('.custom-arrow--prev');
//   const nextBtn = document.querySelector('.custom-arrow--next');
//   const thumbnails = document.querySelector('[id^="GalleryThumbnails"]');
  
//   if (!prevBtn || !nextBtn || !thumbnails) return;

//   function clickAdjacentThumbnail(direction) {
//     // Find the currently active thumbnail
//     const activeThumbnail = thumbnails.querySelector('button[aria-current="true"]');
//     if (!activeThumbnail) return;

//     // Get the parent li element
//     const activeLi = activeThumbnail.closest('[data-target]');
//     if (!activeLi) return;

//     // Get all thumbnail list items
//     const allThumbnails = Array.from(thumbnails.querySelectorAll('[data-target]'));
//     const currentIndex = allThumbnails.indexOf(activeLi);

//     let targetIndex;
//     if (direction === 'prev') {
//       // Don't go back if already at first slide
//       if (currentIndex === 0) return;
//       targetIndex = currentIndex - 1;
//     } else {
//       // Don't go forward if already at last slide
//       if (currentIndex === allThumbnails.length - 1) return;
//       targetIndex = currentIndex + 1;
//     }

//     // Click the button in the target thumbnail
//     const targetButton = allThumbnails[targetIndex].querySelector('button');
//     if (targetButton) {
//       targetButton.click();
//     }

//     // Update button states
//     updateButtonStates(targetIndex, allThumbnails.length);
//   }

//   function updateButtonStates(currentIndex, totalSlides) {
//     // Disable prev button on first slide
//     if (currentIndex === 0) {
//       prevBtn.setAttribute('disabled', 'disabled');
//       prevBtn.style.opacity = '0.3';
//       prevBtn.style.cursor = 'not-allowed';
//     } else {
//       prevBtn.removeAttribute('disabled');
//       prevBtn.style.opacity = '';
//       prevBtn.style.cursor = 'pointer';
//     }

//     // Disable next button on last slide
//     if (currentIndex === totalSlides - 1) {
//       nextBtn.setAttribute('disabled', 'disabled');
//       nextBtn.style.opacity = '0.3';
//       nextBtn.style.cursor = 'not-allowed';
//     } else {
//       nextBtn.removeAttribute('disabled');
//       nextBtn.style.opacity = '';
//       nextBtn.style.cursor = 'pointer';
//     }
//   }

//   // Initialize button states on page load
//   const allThumbnails = Array.from(thumbnails.querySelectorAll('[data-target]'));
//   const activeThumbnail = thumbnails.querySelector('button[aria-current="true"]');
//   if (activeThumbnail) {
//     const activeLi = activeThumbnail.closest('[data-target]');
//     const currentIndex = allThumbnails.indexOf(activeLi);
//     updateButtonStates(currentIndex, allThumbnails.length);
//   }

//   // Add click handlers
//   prevBtn.addEventListener('click', (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     if (!prevBtn.hasAttribute('disabled')) {
//       clickAdjacentThumbnail('prev');
//     }
//   });

//   nextBtn.addEventListener('click', (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     if (!nextBtn.hasAttribute('disabled')) {
//       clickAdjacentThumbnail('next');
//     }
//   });
// });

